module.exports = __webpack_public_path__ + "static/media/usa.cbfe8d83.svg";